import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { SalesPopup } from './components/SalesPopup';
import { Hero } from './components/sections/Hero';
import { Signs } from './components/sections/Signs';
import { Story } from './components/sections/Story';
import { HomeProblems } from './components/sections/HomeProblems';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Method } from './components/sections/Method';
import { Volumes } from './components/sections/Volumes';
import { Tools } from './components/sections/Tools';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-navy antialiased" data-id="element-0" data-mp="3mkrgru1fnxhj">
      <MetaPixel data-id="element-1" data-mp="3rdapodp6e4g0" />
      <main data-id="element-2" data-mp="3rcsyhvhdegey">
        <Hero data-id="element-3" data-mp="3rd18nfm3z7mg" />
        <Signs data-id="element-4" data-mp="3relvej26lm9r" />
        <Story data-id="element-5" data-mp="5otf64sd496" />
        <HomeProblems data-id="element-6" data-mp="67z9oh5w26u" />
        <BeforeAfter data-id="element-7" data-mp="4n6a3ahwrb3" />
        <Method data-id="element-8" data-mp="56qxrrj5tst" />
        <Volumes data-id="element-9" data-mp="7sxbo2oq39g" />
        <Tools data-id="element-10" data-mp="2zld4hgdhhrep" />
        <Bonuses data-id="element-11" data-mp="2zlv8x0aavbxp" />
        <Offer data-id="element-12" data-mp="2zmenc70qri6z" />
        <Guarantee data-id="element-13" data-mp="2zmwguvw0rib7" />
        <Testimonials data-id="element-14" data-mp="2zng2amkvootz" />
        <Author data-id="element-15" data-mp="33m5b01uz1i7a" />
        <FAQ data-id="element-16" data-mp="33nq6btp41567" />
        <FinalCTA data-id="element-17" data-mp="33ngfk3w8qtzg" />
      </main>
      <Footer data-id="element-18" data-mp="33orkw85c49so" />
      <FloatingCTA data-id="element-19" data-mp="38lrpeemjd4ho" />
      <SalesPopup data-id="element-20" data-mp="38l8eviz7tido" />
    </div>;
}